import { colorConstants } from 'config/colorConstants';

export const CUSTOM_LENS_UI = {
    /** Base lens create/edit modal — keep below nested confirm dialogs */
    LENS_MODAL_Z_INDEX: 1000,
    /** Delete lens confirm must stack above LENS_MODAL_Z_INDEX */
    DELETE_LENS_MODAL_Z_INDEX: 1100,
    BUTTON_BORDER_RADIUS: 6,
    MODAL_BORDER_RADIUS: 8,
    LENS_NAME_INPUT_WIDTH: 441,
    DROPDOWN_WIDTH: 254,
    FIELD_LABEL_WIDTH: 88,
    EDIT_WARNING_BANNER_WIDTH: 650,
    /** [horizontal, vertical] gap below the dropdown trigger */
    DROPDOWN_POPOVER_OFFSET: [0, -10] as const,
} as const;

export const CUSTOM_LENS_SELECTION_POPOVER_CLASS = 'custom-lens-selection-popover';

export const CUSTOM_LENS_DROPDOWN_POPOVER_INNER_STYLE = {
    width: CUSTOM_LENS_UI.DROPDOWN_WIDTH,
    borderRadius: CUSTOM_LENS_UI.MODAL_BORDER_RADIUS,
    padding: 0,
    overflow: 'hidden',
    boxSizing: 'border-box' as const,
};

export const CUSTOM_LENS_TOOLTIP_PROPS = {
    color: colorConstants.headerColor,
    placement: 'top' as const,
    overlayInnerStyle: { borderRadius: 8, fontSize: 14, fontWeight: 400 },
};

export const CUSTOM_LENS_WARNING_BANNER_STYLE = {
    borderColor: colorConstants.yellowAlt,
    backgroundColor: colorConstants.lightYellow1,
    iconColor: colorConstants.yellowAlt,
};
